import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router';
import { EditCredentialsTab } from './EditCredentialsTab';
import { EditProfileTab } from './EditProfileTab';
import { SettingsTab } from './SettingsTab';

export interface ProfileTabProps extends RouteComponentProps<any> {
}

@observer export class ProfileTab extends Component<ProfileTabProps, any> {

    render() {
        const { match } = this.props;

        return <>
            <Switch>
                <Route path={`${match.path}/credentials`} component={EditCredentialsTab} />
                <Route path={`${match.path}`} component={EditProfileTab} />
            </Switch>
        </>
    }

}
